export const ITEM_CHANGE_CANCELLED = 'itemChangeCancelled';

/** `'grouped'`: added to the open group of the year, nothing sent; the editor closes as on a save. */
export type PricedItemChangeOutcome =
  | 'written'
  | 'writtenWithVersion'
  | 'grouped'
  | typeof ITEM_CHANGE_CANCELLED;
